(function () {
  const parallax = () => {
    const paralax = document.querySelector(".parallax-gallery");
    if (paralax.classList.contains("slider_started")) {
      return;
    }
    paralax.classList.add("slider_started");
    const section = document.querySelector(".parallax-gallery");
    const img = document.querySelector(".parallax-gallery_img");
  };
  (function () {
    const initParallax = (selector, options = {}) => {
      document.querySelectorAll(selector).forEach((element) => {
        $(element).jarallax(options);
      });
    };

    const initializeAllParallax = () => {
      initParallax(".jarallax");

      initParallax(".jarallax-video");
    };

    document.addEventListener("shopify:section:load", initializeAllParallax);

    window.addEventListener("load", initializeAllParallax);
  })();

  parallax();

  document.addEventListener("shopify:section:load", function () {
    parallax();
  });
})();
